import { defineComponent as p, openBlock as t, createElementBlock as a, mergeProps as u, unref as o, renderSlot as V, createElementVNode as e, createCommentVNode as m } from "vue";
import { useScalarIcon as g } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, A = { key: 1 }, M = { key: 2 }, f = { key: 3 }, H = { key: 4 }, h = { key: 5 }, k = {
  name: "ScalarIconArrowLineLeft"
}, y = /* @__PURE__ */ p({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = g(s);
    return (i, l) => (t(), a("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(d)), [
      V(i.$slots, "default"),
      o(n) === "bold" ? (t(), a("g", Z, l[0] || (l[0] = [
        e("path", { d: "M236,128a12,12,0,0,1-12,12H109l51.52,51.51a12,12,0,0,1-17,17l-72-72a12,12,0,0,1,0-17l72-72a12,12,0,0,1,17,17L109,116H224A12,12,0,0,1,236,128ZM40,28A12,12,0,0,0,28,40V216a12,12,0,0,0,24,0V40A12,12,0,0,0,40,28Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (t(), a("g", A, l[1] || (l[1] = [
        e("path", {
          d: "M144,56V200L72,128Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M224,120H152V56a8,8,0,0,0-13.66-5.66l-72,72a8,8,0,0,0,0,11.32l72,72A8,8,0,0,0,152,200V136h72a8,8,0,0,0,0-16Zm-88,60.69L83.31,128,136,75.31ZM48,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0Z" }, null, -1)
      ]))) : o(n) === "fill" ? (t(), a("g", M, l[2] || (l[2] = [
        e("path", { d: "M48,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0Zm176,80H152V56a8,8,0,0,0-13.66-5.66l-72,72a8,8,0,0,0,0,11.32l72,72A8,8,0,0,0,152,200V136h72a8,8,0,0,0,0-16Z" }, null, -1)
      ]))) : o(n) === "light" ? (t(), a("g", f, l[3] || (l[3] = [
        e("path", { d: "M230,128a6,6,0,0,1-6,6H86.49l61.75,61.76a6,6,0,1,1-8.48,8.48l-72-72a6,6,0,0,1,0-8.48l72-72a6,6,0,0,1,8.48,8.48L86.49,122H224A6,6,0,0,1,230,128ZM40,34a6,6,0,0,0-6,6V216a6,6,0,0,0,12,0V40A6,6,0,0,0,40,34Z" }, null, -1)
      ]))) : o(n) === "regular" ? (t(), a("g", H, l[4] || (l[4] = [
        e("path", { d: "M232,128a8,8,0,0,1-8,8H91.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L91.31,120H224A8,8,0,0,1,232,128ZM40,32a8,8,0,0,0-8,8V216a8,8,0,0,0,16,0V40A8,8,0,0,0,40,32Z" }, null, -1)
      ]))) : o(n) === "thin" ? (t(), a("g", h, l[5] || (l[5] = [
        e("path", { d: "M228,128a4,4,0,0,1-4,4H81.66l65.17,65.17a4,4,0,0,1-5.66,5.66l-72-72a4,4,0,0,1,0-5.66l72-72a4,4,0,1,1,5.66,5.66L81.66,124H224A4,4,0,0,1,228,128ZM40,36a4,4,0,0,0-4,4V216a4,4,0,0,0,8,0V40A4,4,0,0,0,40,36Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  y as default
};
